import type { CrmLeadCardInFunnelData } from '@/api/types/crm/crmFunnels.types'
import type { CrmLeadTaskCounts } from '@/api/types/crm/crmLeadTasks.types'
import {
  EMPTY_CRM_LEAD_TASK_COUNTS,
  normalizeCrmLeadTaskCounts,
} from '../../utils/crmLeadTaskCounts'
import { getLeadFunnelRowId } from './LeadRefetchContext/leadRefetch.utils'
import type { LeadCardApiData } from './leadModalRefetchMerge'
import type { LeadProfileLead } from './LeadProfileModal.types'

export { EMPTY_CRM_LEAD_TASK_COUNTS, normalizeCrmLeadTaskCounts }

function countsFromUnknown(value: unknown): CrmLeadTaskCounts | null {
  if (value == null) return null
  return normalizeCrmLeadTaskCounts(value)
}

/**
 * Счётчики для бейджей вкладки «Задачи» текущей сделки.
 * Приоритет: card-funnel → current_funnels → get-lead funnels → строка списка.
 */
export function resolveLeadProfileTaskCounts(params: {
  leadFunnelId: number | null | undefined
  selectedFunnelId: number | null
  getCardInFunnelSnapshot: (
    funnelId: number,
    leadFunnelId?: number | null,
  ) => CrmLeadCardInFunnelData | undefined
  leadCardSnapshot: LeadCardApiData | null
  lead: LeadProfileLead | undefined
}): CrmLeadTaskCounts {
  const {
    leadFunnelId,
    selectedFunnelId,
    getCardInFunnelSnapshot,
    leadCardSnapshot,
    lead,
  } = params

  const lfId = Number(leadFunnelId)
  const hasLeadFunnel = Number.isFinite(lfId) && lfId > 0
  const funnelId =
    selectedFunnelId != null &&
    Number.isFinite(Number(selectedFunnelId)) &&
    Number(selectedFunnelId) > 0
      ? Number(selectedFunnelId)
      : null

  if (funnelId != null) {
    const snap = getCardInFunnelSnapshot(
      funnelId,
      hasLeadFunnel ? lfId : undefined,
    )
    const fromRoot = countsFromUnknown(snap?.task_counts)
    if (fromRoot) return fromRoot
  }

  const currentFunnels = leadCardSnapshot?.current_funnels
  if (Array.isArray(currentFunnels) && hasLeadFunnel) {
    const row = currentFunnels.find(
      (item) => getLeadFunnelRowId(item) === lfId,
    )
    const fromRow = countsFromUnknown(row?.task_counts)
    if (fromRow) return fromRow
  }

  const rawLeadFunnels = lead != null ? lead.funnels : undefined
  const leadFunnels: Array<{
    lead_funnel_id?: number | string | null
    task_counts?: unknown
  }> = Array.isArray(rawLeadFunnels)
    ? (rawLeadFunnels as Array<{
        lead_funnel_id?: number | string | null
        task_counts?: unknown
      }>)
    : []
  if (leadFunnels.length > 0 && hasLeadFunnel) {
    const funnel = leadFunnels.find(
      (item) => Number(item.lead_funnel_id) === lfId,
    )
    const fromFunnel = countsFromUnknown(funnel?.task_counts)
    if (fromFunnel) return fromFunnel
  }

  if (lead && hasLeadFunnel) {
    const rowLeadFunnelId = Number(
      (lead as { lead_funnel_id?: unknown }).lead_funnel_id,
    )
    if (rowLeadFunnelId === lfId) {
      const fromList = countsFromUnknown(
        (lead as { task_counts?: unknown }).task_counts,
      )
      if (fromList) return fromList
    }
  }

  return { ...EMPTY_CRM_LEAD_TASK_COUNTS }
}
